import md5 from "md5";

import { type Checksum } from "../api-types/checksum";

export const V0_MD5_CHECKSUM_VERSION = "v0_md5";

// v0 of md5 checksum strategy
// The version string is associated with the specific hashing strategy
export const v0md5Checksum = (str: string): Checksum => {
	return {
		version: V0_MD5_CHECKSUM_VERSION,
		hash: md5(str),
	};
};
